import { createContext, useContext } from 'react';

const NavBarContext = createContext({ isMobile: false });
const useNavBarContext = () => useContext(NavBarContext);
const NavBarProvider = NavBarContext.Provider;

export { NavBarContext, NavBarProvider, useNavBarContext };
//# sourceMappingURL=NavBarContext.es.js.map
